import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'createUrl',
  standalone: true
})
export class createUrlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, ...args: unknown[]): any {

    if (value instanceof Blob || value instanceof MediaSource) return URL.createObjectURL(value)
    return value ?? ''
  }

}
